import { useState, useContext, useEffect } from 'react'
import DashboardLayout from '../../../../components/layout/dashboard/DashboardLayout'
import { useTranslation } from 'react-i18next';
import AuthContext from 'contexte/AuthContext';
import './marginTransactions.css'
import { fetchOrders } from 'services/fetchOrders';
import Tableau from 'components/DataComponents/Tableau/Tableau';
import FilterComponent from 'components/Filters/FilterComponent/FilterComponent';
import PageLoader from 'components/pageLoader/PageLoader';
import Badge from 'components/Badge/Badge';
import colors from 'assets/colors';
import { MARGIN_RELEASE_DATE, RELEASE_DATE, formatDate } from 'utils/date';
import { fetchLeverageTransactions } from 'services/marginServices';
import TickerImage from 'components/DataComponents/TickerImage/TickerImage';

const MarginTransactions = () => {

    const { t } = useTranslation();
    const { user } = useContext(AuthContext);

    const [fetchLimit, setFetchLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [transactions, setTransactions] = useState([]);
    // const [pendingCount, setPendingCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [selectedDate, setSelectedDate] = useState({
        date1: { startDate: new Date(MARGIN_RELEASE_DATE), endDate: new Date() },
        date2: { startDate: null, endDate: null },
    });
    const [isPurchase, setIsPurchase] = useState(true);
    const [isSale, setIsSale] = useState(true);
    const [isOnHold, setIsOnHold] = useState(false);
    const [isCanceled, setIsCanceled] = useState(false);

    const getType = () => {
        if (isPurchase && isSale) return 'ALL';
        if (isPurchase) return 'BUY'
        return 'SELL'
    }

    const fetchData = async () => {
        try {
            const data = await fetchLeverageTransactions(user, page, fetchLimit, selectedDate.date1.startDate, selectedDate.date1.endDate, getType())
            setTransactions(data)
            setLoading(false)

        } catch (error) {
            console.error(error)
        }

    }

    useEffect(() => {
        if (selectedDate.date1.startDate !== null && selectedDate.date1.endDate !== null) {
            fetchData()
        }
    }, [fetchLimit, page, selectedDate, isSale, isPurchase, isOnHold, isCanceled])

    const transformDataToTbody = (data) => {
        return data.map((item) => {
            return {
                data: [
                    item.user,
                    <TickerImage ticker={item.ticker} />,
                    item.amount,
                    item.total,
                    <Badge
                        text={item.side}
                        color={colors.badge[item.side]}
                    />,
                    <Badge
                        text={item.type === 'BUY' ? 'ACHAT' : 'VENTE'}
                        color={colors.badge[item.type]}
                    />,
                    formatDate({ date: item.filled_at, time: true })
                ],
                utils: {
                    side: item.side,
                    id: item.id
                }
            }
        })
    }

    const resetFilter = () => {
        setSelectedDate({
            date1: { startDate: new Date(RELEASE_DATE), endDate: new Date() },
            date2: { startDate: null, endDate: null },
        })
        setFetchLimit(10)
    }

    const handleFetchLimit = (newLimit) => {
        setFetchLimit(newLimit);
        setPage(0)
    }


    return (
        <DashboardLayout page={t("pages_name.margin_transactions")}>
            <div>
                {!loading ? (
                    <div>
                        <div className='externalDeposit_titleComponent'>
                            <h2>Liste des transactions</h2>
                            <div className='margin_transactions_filter_components'>
                                <FilterComponent
                                    limit={true}
                                    date={true}
                                    fetchLimit={fetchLimit}
                                    setFetchLimit={handleFetchLimit}
                                    resetFilter={resetFilter}
                                    selectedDate={selectedDate}
                                    setSelectedDate={setSelectedDate}
                                    ordersFilter
                                    isPurchase={isPurchase}
                                    isSale={isSale}
                                    hideCancel
                                    hideOnHold
                                    setIsPurchase={setIsPurchase}
                                    setIsSale={setIsSale}
                                />
                            </div>

                        </div>
                        {/* <p>Nombre d'ordres en attente : {pendingCount}</p> */}
                        <div className="table-container">
                            <div className="table-column">
                                <Tableau
                                    thead={["Utilisateur", "Ticker", "Quantité", "Volume", "Side", "Type", "Date"]}
                                    tbody={transformDataToTbody(transactions)}
                                    limit={fetchLimit}
                                    hadLink
                                    linkPath={'/finances/margin-transaction/'}
                                    pagination
                                    page={page}
                                    setPage={setPage}
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='pageLoaderBox'>
                        <PageLoader />
                    </div>
                )}
            </div>
        </DashboardLayout>
    )
}

export default MarginTransactions